if (!customElements.get("td-accordion-tabs")) {
  class TdAccordionTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll(".td-at__tab");
      this.currentIndex = 0;
      this.autoplay = this.getAttribute("data-autoplay") === "true";
      this.autoplayInterval =
        parseInt(this.getAttribute("data-autoplay-interval"), 10) || 5;
      this.autoplayTimer = null;
    }

    connectedCallback() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => this.activateTab(index));
      });

      const prevButton = this.querySelector(".td-at__tabs-prev");
      const nextButton = this.querySelector(".td-at__tabs-next");

      if (prevButton) {
        prevButton.addEventListener("click", () => {
          this.currentIndex =
            this.currentIndex === 0
              ? this.tabs.length - 1
              : this.currentIndex - 1;
          this.activateTab(this.currentIndex);
        });
      }

      if (nextButton) {
        nextButton.addEventListener("click", () => {
          this.currentIndex =
            this.currentIndex === this.tabs.length - 1
              ? 0
              : this.currentIndex + 1;
          this.activateTab(this.currentIndex);
        });
      }

      this.tabs.forEach((tab, index) => {
        if (tab.hasAttribute("data-open-default")) {
          this.activateTab(index);
        }
      });

      if (this.autoplay) {
        const observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.startAutoplay();
                observer.disconnect();
              }
            });
          },
          { threshold: 0.5 }
        );
        observer.observe(this);
      }
    }

    activateTab(index) {
      this.tabs.forEach((tab) => tab.classList.remove("td-at__tab--active"));
      this.tabs[index].classList.add("td-at__tab--active");
      this.currentIndex = index;
    }

    startAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
      }
      this.autoplayTimer = setInterval(() => {
        this.currentIndex =
          this.currentIndex === this.tabs.length - 1
            ? 0
            : this.currentIndex + 1;
        this.activateTab(this.currentIndex);
      }, this.autoplayInterval * 1000);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  customElements.define("td-accordion-tabs", TdAccordionTabs);
}

if (!customElements.get("td-accordion-wrapper")) {
  class TdAccordionWrapper extends HTMLElement {
    constructor() {
      super();
      this.items = this.querySelectorAll(".td-accordion__item");
    }

    connectedCallback() {
      this.items.forEach((item) => {
        const toggle = item.querySelector(".td-accordion__toggle");
        const content = item.querySelector(".td-accordion__content");

        if (item.getAttribute("data-open") === "true") {
          content.style.maxHeight = content.scrollHeight + "px";
        }

        toggle.addEventListener("click", () => this.toggleItem(item));
      });
    }

    toggleItem(item) {
      const content = item.querySelector(".td-accordion__content");
      const isOpen = item.getAttribute("data-open") === "true";

      if (isOpen) {
        content.style.maxHeight = null;
        item.setAttribute("data-open", "false");
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
        item.setAttribute("data-open", "true");
      }

      this.items.forEach((otherItem) => {
        if (
          otherItem !== item &&
          otherItem.getAttribute("data-open") === "true"
        ) {
          otherItem.querySelector(".td-accordion__content").style.maxHeight =
            null;
          otherItem.setAttribute("data-open", "false");
        }
      });
    }
  }

  customElements.define("td-accordion-wrapper", TdAccordionWrapper);
}
